import {
  GqlModel,
  GqlModelOperator,
  GqlModelListOperator,
  GqlMutationModel,
  GqlQueryModel,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonListIndex, JSONModel, jsonProperty} from "../json.model";
import {DefaultNameIndexEditingGqlModel, EditableListItem} from "../graphql/common.gql-model";
import {QuickFormGroup} from "../helpers/quick-form-group";

export const k2SoftwareSolutionsKeys = [
  "id",
  "customerId",
  "solutionsPn",
  "prdSold",
  "qtyPurchased",
  "qtyDeployed",
  "installDate",
  "solutionsInstallDate",
  "msId",
  "coId",
  "licenseNr",
  "custom1",
  "custom2",
  "region",
  "countryId",
  "dsId",
];

export class K2SoftwareSolutionGqlModel extends GqlQueryModel implements EditableListItem {
  static mapper: GqlModelListOperator<K2SoftwareSolutionGqlModel> =
    GqlModel.buildListMapper(K2SoftwareSolutionGqlModel, "k2SoftwareSolution");

  static query: any = gql`
    query getK2SoftwareSolutionsList($customerId: ID) {
      k2SoftwareSolution(customerId: $customerId) {
        id
        customerId
        solutionsPn
        prdSold
        qtyPurchased
        qtyDeployed
        installDate
        solutionsInstallDate
        msId
        coId
        licenseNr
        custom1
        custom2
        region
        countryId
        dsId
      }
    }
  `;

  editing: boolean = false;
  @jsonListIndex() index: number;

  @jsonProperty("string") id: string;
  @jsonProperty("string") customerId: string;
  @jsonProperty("string") solutionsPn: string;
  @jsonProperty("string") prdSold: string;
  @jsonProperty("number0") qtyPurchased: number;
  @jsonProperty("number0") qtyDeployed: number;
  @jsonProperty("stringDate") installDate: string;
  @jsonProperty("string") solutionsInstallDate: string;
  @jsonProperty("string") msId: string;
  @jsonProperty("string") coId: string;
  @jsonProperty("string") licenseNr: string;
  @jsonProperty("string") custom1: string;
  @jsonProperty("string") custom2: string;
  @jsonProperty("string") region: string;
  @jsonProperty("string") countryId: string;
  @jsonProperty("string") dsId: string;

  @jsonProperty(DefaultNameIndexEditingGqlModel)
  k2SoftwareSolutionItem: DefaultNameIndexEditingGqlModel;

  form: QuickFormGroup = new QuickFormGroup(this, k2SoftwareSolutionsKeys);

  static variables(customerId?: string) {
    return {
      customerId: customerId || null,
    };
  }

  constructor(data?: any) {
    super(data || {});
  }
}

export class K2SoftwareSolutionInputModel extends JSONModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") customerId: string;
  @jsonProperty("string") solutionsPn: string;
  @jsonProperty("string") prdSold: string;
  @jsonProperty("number0") qtyPurchased: number;
  @jsonProperty("number0") qtyDeployed: number;
  @jsonProperty("stringDate") installDate: string;
  @jsonProperty("string") solutionsInstallDate: string;
  @jsonProperty("string") msId: string;
  @jsonProperty("string") coId: string;
  @jsonProperty("string") licenseNr: string;
  @jsonProperty("string") custom1: string;
  @jsonProperty("string") custom2: string;
  @jsonProperty("string") region: string;
  @jsonProperty("string") countryId: string;
  @jsonProperty("string") dsId: string;
}

export class K2SoftwareSolutionInputResponseGqlModel extends GqlModel {
  @jsonProperty("string") id: string;
  @jsonProperty("boolean") updated: boolean;
  @jsonProperty("string") message: string;
}

export class K2SoftwareSolutionInputGqlModel extends GqlMutationModel {
  static mapper: GqlModelOperator<K2SoftwareSolutionInputResponseGqlModel> =
    GqlModel.buildMapper(K2SoftwareSolutionInputResponseGqlModel, "k2softwareSolution");

  static query: any = gql`
mutation updateK2SoftwareSolutions(
  $k2softwareSolutions: [k2SoftwareSolutionInput]!,
  $projectId: ID
) {
  k2softwareSolution: k2softwareSolution(
    softwareSolution: $k2softwareSolutions,
    projectId: $projectId,
  ) {
    __typename
    id
    updated
    message
  }
}
  `;

  static variables(projectId?: string) {
    return {
      projectId: projectId || null,
    };
  }

  @jsonProperty([K2SoftwareSolutionInputModel]) k2softwareSolutions: K2SoftwareSolutionInputModel[];
}
